import { render } from "./object-image.vue?vue&type=template&id=685bf54f"
import script from "./object-image.vue?vue&type=script&lang=js"
export * from "./object-image.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__